export default __webpack_public_path__ + "static/media/libro-legal-design-demuro-imperiale.859b5463.png";